import en from './en.json';
import ja from './ja.json';

const dictionary = { en, ja }

export function recommendedBookmarks(locale: string) {
  // @ts-ignore
  return dictionary[locale] || en
}
